import "core-js/modules/es6.number.constructor.js";
import '@web/shared-digital-library/icons/svg-utilities/filters.svg';
import '@web/shared-digital-library/icons/svg-utilities/order.svg';
export default {
  name: 'StickyButtons',
  props: {
    selected: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onclickButton: function onclickButton(event, type, typeForTracking) {
      this.$emit('open-layer', type);
      this.$root.$emit('sticky-filters', type);
      this.$root.$emit('generic-tracking', event, this.tracking("".concat(typeForTracking, "_Ouverture")));
    },
    tracking: function tracking(arg) {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: arg,
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    }
  }
};